import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { searchActions } from '../../store/searchStore';
import BussinesBulletinSearchForm from './businessBulletin/businessBulletinSearchForm';
import BusinessBulletinSearchResult from './businessBulletin/businessBulletinSearchResult';
import { Switch, withRouter } from "react-router"
import PrivateRoute from '../privateRoute';

import '../../css/search/search.scss';
import '../../css/common/pagination.css';

class BusinessBulletinSearchComponent extends React.Component {
    render() {
        return (
            <div className='content-root'>
                <Switch>
                    <PrivateRoute exact path={`${this.props.match.url}`} component={BussinesBulletinSearchForm} />
                    <PrivateRoute exact path={`${this.props.match.url}/results`} component={BusinessBulletinSearchResult} />
                </Switch>
            </div>
        )
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.search, user: state.userContext }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(BusinessBulletinSearchComponent)));
